<template>
  <div class="menu-side bg--blue-dark tx--bege">
    <div class="hold-menu">
      <div class="head--pad">
        <router-link to="/dashboard">
          <div class="logo">
            <LogoSvg />
          </div>
        </router-link>
        <div class="mm-user">
          <div class="user_row">
            שלום {{ activeUser.name }}.
            <a href="javascript:void(0)" @click="logout()">התנתקות</a>
          </div>
          <router-link to="/messages" class="mm-my-msg">
            <div class="relative">
              <span
                v-show="
                  activeUser &&
                    activeUser.doctor_messages &&
                    activeUser.doctor_messages.length
                "
                class="pathology-dot"
              ></span>
              <img src="/assets/img/svg/sm-mail.svg" />
            </div>
            <div>יש לך <span class="underline">הודעות</span></div>
          </router-link>
        </div>
      </div>
      <nav class="menu">
        <MenuItems
          :items="menuList"
          bell-class="pathology-bell"
          dot-class="pathology-dot"
          :show-active="true"
          item-class="pointer"
          :icon-map="desktopIconMap"
        />
      </nav>
      <div class="mm-bottom">
        <SearchFilter :isMenu="true" />
        <a href="tel:0747049400" class="phone-text flex flex--start">
          <img src="/assets/img/svg/ic-phone-white.svg" alt="" />
          <span>תמיכה</span>
          <a>09-9592974</a>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import menuMixin from "../../mixins/menuMixin.js";
import LogoSvg from "../../assets/img/svg/logo.svg";
import MenuItems from "./MenuItems.vue";
import SearchFilter from "@/components/Shared/SearchFilter.vue";
import { menuList } from "../../utilities/globals.js";

export default {
  name: "MenuDesktop",
  mixins: [menuMixin],
  components: { LogoSvg, MenuItems, SearchFilter },
  data() {
    return {
      menuList,
      desktopIconMap: {
        date: "DateSvg",
        list: "ListSvg",
        pen: "PenWhiteSvg",
        card: "CardSvg",
        lock: "LockSvg",
        upload: "UploadSvg",
        contact: "DocCalanderWhiteSvg"
      }
    };
  }
};
</script>
